export const strategies = [
	{
		width: 110,
		title: 'Plant Id',
		field: 'plant_id',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 200,
		title: 'Part No.',
		field: 'part_no',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'Vendor Code',
		field: 'vendor_code',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 175,
		title: 'Supplier Name',
		field: 'supplier_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 100,
		title: 'Status',
		field: 'approval_status',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'DMP Status',
		field: 'dmp_approval_status',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 180,
		title: 'Assigned DMP',
		field: 'dmp_buyer_status_evaluated_by',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 180,
		title: 'DMP Evaluated At',
		field: 'dmp_buyer_status_evaluated_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 220,
		title: 'DMP Evaluation Ageing',
		field: 'dmp_buyer_evaluation_ageing',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'SCM Status',
		field: 'scm_approval_status',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 180,
		title: 'Assigned SCM',
		field: 'scm_buyer_status_evaluated_by',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 180,
		title: 'SCM Evaluated At',
		field: 'scm_buyer_status_evaluated_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 220,
		title: 'SCM Evaluation Ageing',
		field: 'scm_buyer_evaluation_ageing',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 165,
		title: 'Logistics Status',
		field: 'logistics_approval_status',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 210,
		title: 'Assigned Logistics',
		field: 'logistics_buyer_status_evaluated_by',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 210,
		title: 'Logistics Evaluated At',
		field: 'logistics_buyer_status_evaluated_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 240,
		title: 'Logistics Evaluated Ageing',
		field: 'logistics_buyer_evaluation_ageing',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 180,
		title: 'Commodity Type',
		field: 'commodity_type_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 200,
		title: 'TML Receiving Plant',
		field: 'receiving_location',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 250,
		title: 'Part Description',
		field: 'part_description',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 130,
		title: 'Inco Terms',
		field: 'inco_terms',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 185,
		title: 'Models Applicable',
		field: 'models_applicable',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 165,
		title: 'Annual Volume',
		field: 'annual_volume',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 160,
		title: 'Packaging Cost',
		field: 'supplier_packaging_cost',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 195,
		title: 'Transportation Cost',
		field: 'supplier_transport_cost',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 220,
		title: 'No. of parts per vehicle',
		field: 'part_per_vehicle',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 150,
		title: 'Part Weight',
		field: 'part_weight',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 170,
		title: 'Part Dimensions',
		field: 'part_dimension_length',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 110,
		title: 'Feedbacks',
		field: 'feedbacks',
		enableSearch: false,
		enableFilter: false,
	},
	// {
	// 	width: 110,
	// 	title: 'Excel',
	// 	field: 'excel',
	// 	enableSearch: false,
	// 	enableFilter: false,
	// },
	{
		width: 160,
		title: 'Updated At',
		field: 'updated_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Updated By',
		field: 'updated_by',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Created At',
		field: 'created_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Created By',
		field: 'created_by',
		enableSearch: true,
		enableFilter: true,
	},
];

export const strategiesSupplier = [
	{
		width: 110,
		title: 'Plant Id',
		field: 'plant_id',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 200,
		title: 'Part No.',
		field: 'part_no',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'Vendor Code',
		field: 'vendor_code',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 175,
		title: 'Supplier Name',
		field: 'supplier_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 100,
		title: 'Status',
		field: 'approval_status',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'DMP Status',
		field: 'dmp_approval_status',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'SCM Status',
		field: 'scm_approval_status',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 165,
		title: 'Logistics Status',
		field: 'logistics_approval_status',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 180,
		title: 'Commodity Type',
		field: 'commodity_type_name',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 200,
		title: 'TML Receiving Plant',
		field: 'receiving_location',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 250,
		title: 'Part Description',
		field: 'part_description',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 130,
		title: 'Inco Terms',
		field: 'inco_terms',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 185,
		title: 'Models Applicable',
		field: 'models_applicable',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 165,
		title: 'Annual Volume',
		field: 'annual_volume',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 160,
		title: 'Packaging Cost',
		field: 'supplier_packaging_cost',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 195,
		title: 'Transportation Cost',
		field: 'supplier_transport_cost',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 220,
		title: 'No. of parts per vehicle',
		field: 'part_per_vehicle',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 150,
		title: 'Part Weight',
		field: 'part_weight',
		enableSearch: true,
		enableFilter: true,
	},

	{
		width: 170,
		title: 'Part Dimensions',
		field: 'part_dimension_length',
		enableSearch: true,
		enableFilter: true,
	},
	// {
	// 	width: 110,
	// 	title: 'Reupload',
	// 	field: 'reupload',
	// 	enableSearch: false,
	// 	enableFilter: false,
	// },
	{
		width: 110,
		title: 'Feedbacks',
		field: 'feedbacks',
		enableSearch: false,
		enableFilter: false,
	},
	// {
	// 	width: 110,
	// 	title: 'Excel',
	// 	field: 'excel',
	// 	enableSearch: false,
	// 	enableFilter: false,
	// },
	{
		width: 160,
		title: 'Updated At',
		field: 'updated_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Updated By',
		field: 'updated_by',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Created At',
		field: 'created_at',
		enableSearch: true,
		enableFilter: true,
	},
	{
		width: 160,
		title: 'Created By',
		field: 'created_by',
		enableSearch: true,
		enableFilter: true,
	},
];
